/**
 * BP-11 R3's `X-App-Version`, as the running bundle knows it.
 *
 * `__APP_VERSION__` is replaced at build time by `vite.config.ts` from
 * `web/package.json`. A constant and not a fetch: the header has to be on
 * the *first* request, including the one that would tell the app it is too
 * old, and a build that could not say which build it is would be exactly
 * the one rule R3 exists to turn away.
 */

/** What an unbuilt bundle reports — a dev server, or a unit test. */
export const UNBUILT_VERSION = '0.0.0';

/** The header R3 names. */
export const APP_VERSION_HEADER = 'X-App-Version';

/**
 * `raw` if it is a version, `UNBUILT_VERSION` otherwise.
 *
 * The empty string is not a version: `define` with an unset `version` field
 * would substitute one, and `X-App-Version: ` compares as older than every
 * floor — which would lock out the dev server rather than the old build R3
 * is about.
 */
export function versionOr(raw: unknown): string {
  return typeof raw === 'string' && raw !== '' ? raw : UNBUILT_VERSION;
}

/**
 * The version this bundle was built from.
 *
 * `globalThis` rather than the bare identifier: `define` rewrites the bare
 * one at build time and leaves a `ReferenceError` behind in a bundle that
 * was not built — a unit test, or a dev server started without the config.
 * Reading it off the global is the same value with no branch in it.
 */
export const APP_VERSION: string = versionOr(
  (globalThis as { __APP_VERSION__?: unknown }).__APP_VERSION__,
);
